//back to this
import { useMyBooking } from "./modules/useMyBooking";
import { AddOnServices } from "./molecules/addOnServices";
import { BookingInformation } from "./molecules/bookingInformation";
import { RoomDetails } from "./molecules/roomDetails";

const MyBookingScreen = () => {
  const {
    branding,
    bookingId,
    transactionId,
    bookingDetails,
    isLoading,
    modification,
    setModification,
    validateBooking,
    modifyBooking,
    cancelBooking,
    setTransactionId,
    setBookingId,
  } = useMyBooking();

  if (!branding) {
    return <p>Loading branding...</p>;
  }

  return (
    <div
      className="container mt-4"
      style={{
        backgroundImage: `#fff`,
        backgroundSize: "cover",
        padding: "20px",
        borderRadius: "8px",
      }}
    >
      <h1
        style={{
          color: branding.headingColor,
          fontFamily: branding.headingFont,
        }}
      >
        Manage Your Booking
      </h1>
      <p>Input both Booking Id and Transaction Id to validate your booking</p>
      <div className="form-group mt-3">
        <label>Booking ID</label>
        <input
          type="text"
          className="form-control"
          value={bookingId}
          onChange={(e) => setBookingId(e.target.value)}
        />
      </div>
      <div className="form-group mt-3">
        <label>Transaction ID</label>
        <input
          type="text"
          className="form-control"
          value={transactionId}
          onChange={(e) => setTransactionId(e.target.value)}
        />
      </div>
      <button
        className="btn btn-primary mt-3"
        onClick={validateBooking}
        disabled={isLoading}
      >
        {isLoading ? "Validating..." : "Validate"}
      </button>

      {bookingDetails && (
        <div className="mt-4">
          <h3
            style={{
              color: branding.headingColor,
              fontFamily: branding.headingFont,
            }}
          >
            Modify Booking Details
          </h3>
          <div className="form-group mt-3">
            <label>Guest Name</label>
            <input
              type="text"
              className="form-control"
              value={modification.guestName}
              onChange={(e) =>
                setModification({ ...modification, guestName: e.target.value })
              }
            />
          </div>
          <div className="form-group mt-3">
            <label>Guest Email</label>
            <input
              type="email"
              className="form-control"
              value={modification.guestEmail}
              onChange={(e) =>
                setModification({ ...modification, guestEmail: e.target.value })
              }
            />
          </div>
          <div className="form-group mt-3">
            <label>Guest Nationality</label>
            <input
              type="text"
              className="form-control"
              value={modification.guestNationality}
              onChange={(e) =>
                setModification({
                  ...modification,
                  guestNationality: e.target.value,
                })
              }
            />
          </div>
          <div className="form-group mt-3">
            <label>Special Request</label>
            <textarea
              className="form-control"
              value={modification.specialRequest}
              onChange={(e) =>
                setModification({
                  ...modification,
                  specialRequest: e.target.value,
                })
              }
            />
          </div>

          <BookingInformation
            branding={branding}
            bookingDetails={bookingDetails}
          />

          {/* Room Details */}
          <RoomDetails branding={branding} bookingDetails={bookingDetails} />

          {/* Add-On Services */}
          <AddOnServices branding={branding} bookingDetails={bookingDetails} />

          <button className="btn btn-success mt-3" onClick={modifyBooking}>
            Modify Booking
          </button>
          <button className="btn btn-danger mt-3 ms-2" onClick={cancelBooking}>
            Cancel Booking
          </button>
        </div>
      )}
    </div>
  );
};

export default MyBookingScreen;
